export default "__VITE_ASSET__16c19848__"